import { usePlanStore } from "../stores/plan-store";

export function usePlan() {
	const planDetails = usePlanStore((state) => state.planDetails);
	const isLoading = usePlanStore((state) => state.isLoading);
	const error = usePlanStore((state) => state.error);
	const getPlan = usePlanStore((state) => state.getPlan);
	const clearPlan = usePlanStore((state) => state.clearPlan);

	return {
		planDetails,
		isLoading,
		error,
		getPlan,
		clearPlan,
	};
}